import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import { vulnerabilityRangeTypesMap } from '~/constants/ModelConstants';
import ArtifactViewMainContentFixInfoHowToFixDirect from '~/artifact/containers/ArtifactViewMainContentFixInfoHowToFixDirect';
import ArtifactViewMainContentFixInfoHowToFixTransitive from '~/artifact/containers/ArtifactViewMainContentFixInfoHowToFixTransitive';
import ArtifactViewMainContentFixInfoHowToFixPatch from '~/artifact/containers/ArtifactViewMainContentFixInfoHowToFixPatch';
import ArtifactViewMainContentFixInfoFixDetailsHeader from '~/artifact/containers/ArtifactViewMainContentFixInfoFixDetailsHeader';
type ArtifactViewMainContentFixInfoHowToFixProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentFixInfoHowToFix extends React.Component<
  ArtifactViewMainContentFixInfoHowToFixProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    let store = this.props.artifactState,
      components = store.affectedComponents, //this.props.components || [],
      currentComponentId = store.componentId,
      activeVulnRangeTab = store.activeVulnRangeTab || vulnerabilityRangeTypesMap.VERSIONS,
      activeCommitHash = store.commitHash || '',
      activeSafeCommitHash = store.activeSafeCommitHash || '',
      currentComponent =
        _.find(components, component => {
          return component.id === currentComponentId;
        }) || {},
      currentVersionRange = store.vulnerableRangeByComponent[currentComponentId] || {},
      currentFixSection = store.fixSection,
      howToFixDetailsElementLookup = {
        direct: (
          <ArtifactViewMainContentFixInfoHowToFixDirect
            component={currentComponent}
            range={currentVersionRange}
          />
        ),
        transitive: (
          <ArtifactViewMainContentFixInfoHowToFixTransitive
            component={currentComponent}
            range={currentVersionRange}
          />
        ),
        patch: <ArtifactViewMainContentFixInfoHowToFixPatch range={currentVersionRange} />,
      },
      howToFixDetailsElement = howToFixDetailsElementLookup[currentFixSection],
      howToFixDetailsHeaders = [],
      fixInfoByComponentAndCommitHash = store.fixInfoByComponentAndCommitHash;
    const {
      [currentComponentId]: componentCommitHashes = {},
      errorMessage,
      isFetching,
    } = fixInfoByComponentAndCommitHash;
    const { [activeCommitHash]: componentCommitHashFixInfo = {} } = componentCommitHashes;
    const { hasVulns } = componentCommitHashFixInfo;
    howToFixDetailsHeaders.push(
      <div className="inline-block pl" key="direct">
        <ArtifactViewMainContentFixInfoFixDetailsHeader
          text="Direct"
          section="direct"
          activeSection={currentFixSection}
        />
      </div>
    );
    howToFixDetailsHeaders.push(
      <div className="inline-block" key="transitive">
        <ArtifactViewMainContentFixInfoFixDetailsHeader
          text="Transitive"
          section="transitive"
          activeSection={currentFixSection}
        />
      </div>
    );
    howToFixDetailsHeaders.push(<div className="inline-block" key="patch" />);
    let howToFixHtml = '';
    if (activeVulnRangeTab === vulnerabilityRangeTypesMap.VERSIONS) {
      howToFixHtml = (
        <div>
          <div className="grid__item col-1-1 pt-">
            <div className="font--h7">How to fix your project</div>
          </div>
          <div className="grid__item col-1-2 pt-">
            <div className="grid ph flex flex--justify-content--space-between">
              {howToFixDetailsHeaders}
            </div>
          </div>
          <div className="grid__item col-1-1 pt">{howToFixDetailsElement}</div>
        </div>
      );
    }
    if (activeVulnRangeTab === vulnerabilityRangeTypesMap.COMMIT_HASHES) {
      if (activeSafeCommitHash && !hasVulns) {
        howToFixHtml = (
          <div>
            <div className="grid__item col-1-1">
              <div className="p- mb bo-rad--3 bg-color--white-dark">
                {activeSafeCommitHash} has no vulnerabilities
              </div>
              <div className="font--h7 pb-">How to fix your project</div>
            </div>
            <div className="grid__item col-1-2 pt-">
              <div className="grid ph flex flex--justify-content--space-between">
                {howToFixDetailsHeaders}
              </div>
            </div>
            <div className="grid__item col-1-1 pt">{howToFixDetailsElement}</div>
          </div>
        );
      } else if (activeCommitHash && hasVulns) {
        howToFixHtml = (
          <div>
            <div className="grid__item col-1-1 pt-">
              <div className="grid ph flex flex--justify-content--space-between">
                {activeCommitHash} has vulnerabilities. Please try another commit hash.
              </div>
            </div>
          </div>
        );
      }
      if (errorMessage !== null) {
        howToFixHtml = (
          <div>
            <div className="grid__item col-1-1 pt-">
              <div className="grid ph flex flex--justify-content--space-between color--danger">
                Library does not contain this commit hash. Please try again.
              </div>
            </div>
          </div>
        );
      }
      if (!activeCommitHash) {
        howToFixHtml = (
          <div>
            <div className="grid__item col-1-1 pt-">
              <div className="grid ph flex flex--justify-content--space-between color--danger">
                Please enter a valid commit hash.
              </div>
            </div>
          </div>
        );
      }
      if (isFetching) {
        howToFixHtml = (
          <div>
            <div className="grid__item col-1-1 pt-">
              <div className="grid ph flex flex--justify-content--space-between">Loading ...</div>
            </div>
          </div>
        );
      }
    }
    return <div className="grid">{howToFixHtml}</div>;
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoHowToFix);
